export default function (accountName, accountId = null) {
  const name = accountName != null && accountName !== '' ? accountName : 'My account'

  return accountId != null ? `${name} (${accountId})` : name
}
